import { ChangeEvent, FC, ReactElement, useCallback } from 'react';
import Textarea from '~/view/components/Controls/Textarea/Textarea';
import './style.scss';

interface IProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const GoogleTagManagerTextArea: FC<IProps> = (props: IProps): ReactElement => {
  const onChange = useCallback((event: ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange(event.target.value);
  }, []);

  return <Textarea value={props.value} onChange={onChange} placeholder={props.placeholder} textAreaClassName="google-tag-manager-text-area" />;
};

export default GoogleTagManagerTextArea;
